import { render, staticRenderFns } from "./AddTool.vue?vue&type=template&id=274f606f&"
import script from "./AddTool.vue?vue&type=script&lang=ts&"
export * from "./AddTool.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports